import React from "react"

import EventsSectionDesktop from "./EventsSectionDesktop"
import EventsSectionMobile from "./EventsSectionMobile"

const EventsSection = ({
  section,
  practice,
  theme,
  highlightedField,
  viewMode = "",
  deviceType = "desktop",
  pageSlug = null
}) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <EventsSectionMobile
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  if (viewMode === "desktop") {
    return (
      <EventsSectionDesktop
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <EventsSectionMobile
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
        pageSlug={pageSlug}
      />
    )
  }

  // Default to desktop for desktop devices
  return (
    <EventsSectionDesktop
      section={section}
      practice={practice}
      theme={theme}
      highlightedField={highlightedField}
      pageSlug={pageSlug}
    />
  )
}

export default EventsSection
